import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import './assets/index.css'
import store from "./store";
import can from './directives/can'
import owner from './directives/owner'

const app = createApp(App);
app.directive('can', can)
app.directive('owner', owner)
app.use(router);
app.use(store);
app.mount('#app')
